import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-order-detail",
  imports: [CommonModule],
  templateUrl: "./skeleton-order-detail.component.html",
  styleUrl: "./skeleton-order-detail.component.scss",
})
export class SkeletonOrderDetailComponent {}
